import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { ContainerCommand, ContainerResponse, ContainerSnapshot, ContainerTarget } from "./model.ts";

export interface ContainerApiShape {
  readonly load: (workspaceId: string) => Effect.Effect<ContainerSnapshot, ResourceFailure>;
  readonly control: (target: ContainerTarget, command: ContainerCommand) => Effect.Effect<ContainerResponse, ResourceFailure>;
}
export class ContainerApi extends Context.Service<ContainerApi, ContainerApiShape>()("workerstation/frontend/ContainerApi") {}
